<template>
  <svg
    width="30"
    height="34"
    viewBox="0 0 30 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6886 28.565C9.51721 27.1426 6.90752 24.8963 5.15417 21.6024C2.82796 17.2307 3.10421 10.7616 3.42706 7.56687C3.53205 6.52829 4.41792 5.74364 5.46717 5.76127C6.67063 5.78215 8.34524 5.69729 10.0625 5.25013C11.7719 4.80494 13.205 3.70369 14.1841 2.75323C14.9689 1.99143 16.2183 1.99143 17.0037 2.75323C17.9828 3.70369 19.4159 4.80494 21.1253 5.25013C22.8235 5.69272 24.4791 5.7802 25.68 5.76192C26.7443 5.7456 27.64 6.55048 27.724 7.60603C27.976 10.7818 28.1118 17.1178 25.8013 21.4601C25.0717 22.8316 24.2035 24.1045 23.2855 25.2619C19.7958 29.6617 17.2236 29.2178 14.1841 32"
      stroke="#D3CAF1"
      stroke-width="2.96"
      stroke-miterlimit="10"
    />
    <path
      d="M18.2483 26.3212L13.3215 21.6101C12.0498 20.4521 10.9008 19.3032 9.8752 18.1634C8.84957 17.0236 8.33643 15.767 8.33643 14.3942C8.33643 13.2721 8.71439 12.3353 9.47033 11.5833C10.2263 10.8313 11.1679 10.4553 12.2959 10.4553C12.9318 10.4553 13.5315 10.5898 14.0959 10.8581C14.6595 11.1264 15.1399 11.4939 15.5355 11.9593M15.5355 11.9593C15.5355 11.9593 15.8715 15.2135 14.2159 14.1657C12.5604 13.118 15.5355 11.9593 15.5355 11.9593Z"
      stroke="#462170"
      stroke-width="1.56123"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.8135 24.7175C15.1095 23.5595 20.1845 19.319 21.2042 18.1734C22.2239 17.0277 22.7338 15.7678 22.7338 14.3957C22.7338 13.2736 22.3558 12.3368 21.5999 11.5848C20.844 10.8328 19.9023 10.4568 18.7743 10.4568C18.1385 10.4568 17.5387 10.5913 16.9744 10.8596C16.4107 11.1278 15.9304 11.4954 15.5347 11.9608"
      stroke="#462170"
      stroke-width="1.56123"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
